import getRequestAsPromise from './getRequestAsPromise.js';
import toggleDropdown from '../dom/toggleDropdown.js';

var loadCssForComponent = function(element, mainContainer, fileNames) {
  if(fileNames && fileNames.length) { 
    fileNames.forEach(function(fileName, index){ 
      getRequestAsPromise("GET", fileName, null).then(function(response){
        var elem = document.createElement('style');
        var prefix = ((index === 0)? 'css': index);
        if(fileName.indexOf('mobile') > -1){
          prefix = 'mobile';
          elem.setAttribute("media", "screen and (max-width: 576px)");
        }else if(fileName.indexOf('tablet') > -1){
          prefix = 'tablet';
          elem.setAttribute("media", "screen and (min-width: 768px) and (max-width: 991px)");
        } else if(fileName.indexOf('desktop') > -1){
          prefix = 'desktop';
          elem.setAttribute("media", "screen and (min-width: 992px)");
        }
        var styleId = "load-external-" + prefix;
        elem.setAttribute("id", styleId);
        elem.innerHTML = response;
        if(element.shadowRoot.querySelector('#' + mainContainer) && element.shadowRoot.querySelector('#' + styleId) == null){
          element.shadowRoot.querySelector('#' + mainContainer).insertBefore(elem, element.shadowRoot.querySelector('#' + mainContainer).childNodes[0]);
        }
      }, function(error){ 
        //Do nothing
      });
    });
  }
  element.addEventListener("on-body-click", function(e){
    toggleDropdown(e.detail, element.shadowRoot.querySelector("#" + mainContainer));
  });
}

export default loadCssForComponent;